import React, {Component} from 'react';
import { Form, Modal } from 'react-bootstrap';

class MapServiceLayerForm extends Component<any,any>  {
    constructor(props: any) {
        super(props);
        
        this.state = {
            serviceAddress: this.props.selectedLayerServiceObject.instanceURL, 
        };
    }

    componentDidUpdate(prevProps:any) {
        if(this.props.selectedLayerService !== prevProps.selectedLayerService){
            this.setState({
                serviceAddress: this.props.selectedLayerServiceObject.instanceURL,
            });
            this.render();
        }
    }

    componentDidMount() {
        console.log("MapServiceLayerForm > this.props", this.props)
    }

    updateURL(e: any) {
        e.preventDefault();
        this.setState({
            serviceAddress: e.target.value
        });
    }    
    
    saveToConfig(e: any) {
        if (e){
            e.preventDefault();
        }
        console.log(this)
        console.log(this.state)
        console.log(this.state.serviceAddress)
        let config = {
            URL: this.state.serviceAddress,
            type: this.props.selectedLayerService,
        };

        // pass back to caller.
        console.log("Saving service config", config); 
        
        if(this.props.saveServiceConfig) {
            this.props.saveServiceConfig(config);
        }
    }

    validate() : boolean {
        return true;
    }

    render() {
        console.log("112621 render () > this.props.selectedLayerService", this.props.selectedLayerService)
        console.log("112621 render () > this.state.serviceAddress", this.state.serviceAddress)
        return (<>
            <h4>Create {this.props.selectedLayerService}</h4>
            <Form style={{marginTop: "5px"}}>
                <Form.Label>Service URL</Form.Label>
                <Form.Control type="text" onChange={(e:any) => this.updateURL(e)} value={this.state.serviceAddress ? this.state.serviceAddress: ''}/>
                {/*<div style={{paddingTop: "7px"}}>
                    <Button variant="warning" onClick={(e:any) => this.saveToConfig(e)}>Load Service</Button>
                </div>*/}
            </Form>
        </>);
    }
}

export default MapServiceLayerForm;